import _ from 'lodash-es';
import { normalAOP } from '../common';
_.clone = normalAOP(
  _.clone,
  () => {
    console.log('clone before');
  },
  () => {
    console.log('clone after');
  }
);
export default _;
